import { render, staticRenderFns } from "./xkPicker.vue?vue&type=template&id=4ad3be52&scoped=true&"
import script from "./xkPicker.vue?vue&type=script&lang=js&"
export * from "./xkPicker.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/global.less?vue&type=style&index=0&id=4ad3be52&lang=less&scoped=true&"
import style1 from "./xkPicker.vue?vue&type=style&index=1&id=4ad3be52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad3be52",
  null
  
)

component.options.__file = "xkPicker.vue"
export default component.exports